import "./Services.css";
import "animate.css";

const Services = () => {
  return (
    <>
      <div className="container w-[80%] mx-auto mt-28 mb-28 px-4" id="services">
        <div>
          <p className="text-5xl font-bold text-center mb-12">SERVICES</p>

          <div className="flex flex-col gap-12 md:flex-row-reverse md:gap-8 mt-12 mb-12">
           {/* div one webdev */}
            <div className="flex-1 flex justify-center">
              <lottie-player
                src="https://lottie.host/8e974afd-15d6-449e-980f-89d9f7c5cbd0/TUPLjxSfuU.json"
                background="##FFFFFF"
                speed="1"
                style={{ width: "250px", height: "250px" }}
                loop
                autoplay
                direction="1"
                mode="normal"
              ></lottie-player>
            </div>
            {/* div two security */}
            <div className="flex-1 md:pr-6">
              <h2 className="text-3xl font-bold mb-5 text-center md:text-left">
                Web Development
              </h2>
              <p className="text-base md:text-lg">
                Elevate your online presence with Bytesafe Technologies’ expert
                web development solutions. Our team specializes in crafting
                responsive websites that adapt seamlessly across devices. From
                personalized web applications to innovative solutions, we
                prioritize security in every aspect. Choose us for web
                development that blends creativity, functionality, and robust
                security, creating a powerful digital footprint for your
                business.
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-12 md:flex-row md:gap-8">
            <div className="flex-1 flex justify-center ">
              <lottie-player
                // src="https://lottie.host/23269cc4-04b6-48fc-9051-5f81d3fa309a/6vm89X0FI4.json"
                src="https://lottie.host/dadfc7b1-504a-46c6-b0f7-43ef34c8acae/yQu8CySBd6.json"
                background="##FFFFFF"
                speed="1"
                style={{ width: "100%", maxWidth: "400px", height: "auto" }}
                loop
                autoplay
                direction="1"
                mode="normal"
              ></lottie-player>
            </div>
            <div className="flex-1 md:pl-6">
              <h2 className="text-3xl font-bold mb-5 text-center md:text-left">
                Cyber Security
              </h2>
              <p className=" text-base md:text-lg">
                Protect your digital assets with Bytesafe Technologies’
                cutting-edge cybersecurity services. Our experts conduct
                meticulous audits, vulnerability assessments, and penetration
                testing to fortify your defenses. Tailoring holistic solutions,
                we empower businesses with proactive strategies against evolving
                cyber threats. Choose Bytesafe Technologies for comprehensive
                cybersecurity, ensuring a secure and resilient digital
                environment for your organization.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Services;

// import React from "react";
// import { useEffect } from "react";
// import gsap from "gsap";
// import ScrollTrigger from "gsap/ScrollTrigger";
// import Box from "@mui/material/Box";

// gsap.registerPlugin(ScrollTrigger);

// function ServiceType() {
// 	useEffect(() => {
// 		let ctx = gsap.context(() => {
// 			gsap.set(".photo:not(:first-child)", { opacity: 0, scale: 0.5 })

// 			const animation = gsap.to(".photo:not(:first-child)", {
// 				opacity: 1, scale: 1, duration: 1, stagger: 1
// 			})

// 			ScrollTrigger.create({
// 				trigger: ".gallery",
// 				start: "top top",
// 				end: "bottom bottom",
// 				pin: ".rightblock",
// 				animation: animation,
// 				scrub: true,
// 				markers: true,
// 			})
// 		})
// 		return () => ctx.revert();
// 	}, [])
// 	return (
// 		<>
// 			<Box className="gallery" sx={{ display: "flex" }}>
// 				<Box className="left" sx={{
// 					width: "50%",
// 					marginLeft: "auto",
// 					"& .details": {
// 						height: "100vh",
// 						display: "flex",
// 						flexDirection: "column",
// 						justifyContent: "center",
// 						width: "40vw",
// 						marginLeft: "auto",
// 						color: "#000",
// 						fontSize: "2rem",
// 						fontWeight: 900,
// 					}
// 				}}>
// 					<Box className="details">
// 						WEB Development
// 					</Box>
// 					<Box className="details">
// 						CYBER SECURITY
// 					</Box>
// 					<Box className="details">

// 					</Box>
// 				</Box>
// 				<Box className="rightblock" sx={{
// 					width: "50%",
// 					height: "100vh",
// 					display: "flex",
// 					flexDirection: "column",
// 					justifyContent: "center",
// 				}}>
// 					<Box sx={{
// 						width: "40vw",
// 						height: "40vw",
// 						position: "relative",
// 						"& .photo": {
// 							position: "absolute",
// 							width: "100%",
// 							height: "100%",
// 							"& img": {
// 								height: "100%",
// 								width: "100%",
// 							}
// 						}
// 					}}>
// 						<Box className="photo">
// 							<img
// 								src="http://static.showit.co/800/M0IzUCMvQCqlJn1YtNlikw/59514/pexels-yan-5793641-1.jpg"
// 								alt="img-1" />
// 						</Box>
// 						<Box className="photo">
// 							<img
// 								src="http://static.showit.co/800/137NFxuzSxeyjlons2WEzA/59514/pexels-yan-5793643.jpg"
// 								alt="img-2" />
// 						</Box>
// 						<Box className="photo">
// 							<img
// 								src="http://static.showit.co/800/3kOLYaOCS1SMieN6Y88Fqg/59514/mukuko-studio-mu88mlefcou-unsplash.jpg"
// 								alt="img-3" />
// 						</Box>
// 					</Box>
// 				</Box>
// 			</Box>
// 		</>
// 	);
// }

// export default ServiceType;

// import React, { useEffect } from "react";
// import gsap from "gsap";
// import ScrollTrigger from "gsap/ScrollTrigger";
// import webapps from "../assets/imuimu2.png";

// gsap.registerPlugin(ScrollTrigger);

// function ServiceType() {
//   useEffect(() => {
//     let ctx = gsap.context(() => {
//       gsap.set(".photo:not(:first-child)", { opacity: 0, scale: 0.5 });

//       const animation = gsap.to(".photo:not(:first-child)", {
//         opacity: 1,
//         scale: 1,
//         duration: 1,
//         stagger: 1,
//       });

//       ScrollTrigger.create({
//         trigger: ".gallery",
//         start: "top top",
//         end: "bottom bottom",
//         pin: ".rightblock",
//         animation: animation,
//         scrub: true,
//         markers: true,
//       });
//     });
//     return () => ctx.revert();
//   }, []);

//   return (
//     <>
//       <div className="gallery flex flex-col flex-col-reverse lg:flex-row">
//         <div className="left w-full lg:w-1/2 ml-auto">
//           <div className="details h-auto lg:h-screen flex flex-col justify-center w-full lg:w-[40vw] ml-auto text-3xl lg:text-4xl font-black ">
//             <div className="px-5 bg-[#352F8F] max-[640px]:text-white lg:bg-transparent md:bg-transparent xl:bg-transparent lg:px-10 z-10 border-transparent text-center  pt-5">WEB Development</div>
//             <p className="text-base relative z-10   max-[640px]:text-white lg:text-lg px-5 lg:px-10 pt-10 py-10 lg:py-5 bg-[#352F8F] lg:bg-transparent md:bg-transparent xl:bg-transparent ">
//               Elevate your online presence with Bytesafe Technologies expert web
//               development solutions. Our team specializes in crafting responsive
//               websites that adapt seamlessly across devices. From personalized
//               web applications to innovative solutions, we prioritize security
//               in every aspect. Choose us for web development that blends
//               creativity, functionality, and robust security, creating a
//               powerful digital footprint for your business.
//             </p>
//           </div>
//           <div className="details h-auto lg:h-screen flex flex-col justify-center w-full lg:w-[40vw] ml-auto text-3xl lg:text-4xl font-black">
//             <div className="px-5 bg-[#352F8F] max-[640px]:text-white lg:bg-transparent md:bg-transparent xl:bg-transparent lg:px-10 z-10 border-transparent text-center ">CYBER SECURITY</div>
//             <p className="text-base relative z-10 lg:text-lg px-5 lg:px-10 py-3 lg:py-5 bg-[#352F8F] max-[640px]:text-white lg:bg-transparent md:bg-transparent xl:bg-transparent ">
//               Protect your digital assets with Bytesafe Technologies
//               cutting-edge cybersecurity services. Our experts conduct
//               meticulous audits, vulnerability assessments, and penetration
//               testing to fortify your defenses. Tailoring holistic solutions, we
//               empower businesses with proactive strategies against evolving
//               cyber threats. Choose Bytesafe Technologies for comprehensive
//               cybersecurity, ensuring a secure and resilient digital environment
//               for your organization.
//             </p>
//           </div>
//         </div>
//         <div className="rightblock w-full lg:w-1/2 h-auto lg:h-screen flex flex-col justify-center">
//           <div className="relative w-[90vw] lg:w-[40vw] h-[90vw] lg:h-[40vw] mx-auto lg:mx-0">
//             <div className="photo absolute w-full h-full flex items-center justify-center">
//               <img
//                 src={webapps}
//                 alt="img-1"
//                 className="h-[70%] w-full object-cover z-1"
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default ServiceType;
